module.exports = __webpack_public_path__ + "static/media/signal-alt.28999b2a.svg";